import React from 'react'
import { Row, Col, Button, NavItem, Nav } from 'reactstrap';
import { Link } from 'react-router'

import UpdateProviderContainer from '../../provider/containers/UpdateProviderContainer'


class NewLead extends React.Component {

	constructor(props) { 
        super(props);

    }

    renderForm(){
        return(
            <div className="provider-bloc">
                <Row>
                    <Col>
                        <Link to="/manager/leads"><Button className="btn-transparent"> Retour </Button></Link>

                        <Nav className="provider-navbar">
                          <NavItem className="active">
                            <div  className="provider-navbar-item">Inscription</div>
                          </NavItem>
                        </Nav>

                    </Col>
                </Row>

                <div className="provider-bloc-form">
                    
                        <Col>
                            <div className="title"> Nouveau Lead </div>
                        </Col>
                    
                </div>
            </div>
        )
    }

    render() {
    	
    	return (
            <div className="page-manager">
                 <UpdateProviderContainer provider_id={null} lead={true} create={true}/>
            </div>
        )
    }
}


export default NewLead



// WEBPACK FOOTER //
// ./src/btob/components/NewLead.js